import { useCacheServices } from './cacheServices';
import { useDocumentServices } from './documentServices';
import { useClientServices } from './clientServices';
import { useAppointmentServices } from './appointmentServices';

/**
 * Main API services hook that aggregates all service modules
 * @param {Function} dispatch - Redux dispatch function for state updates
 * @returns {Object} Object containing all API service functions
 */
export const useApiServices = (dispatch) => {
    const { callCacheService } = useCacheServices();
    const { getAvailableDocuments } = useDocumentServices(dispatch);
    const {
        getFinAccounts,
        callActionService,
        getClientUserStatus,
        putClientUserStatus,
        getKycInfo,
        getClientPreferences,
        getYodleeResponse
    } = useClientServices(dispatch);
    const { getAppointmentDetails, redirectToTimeTrade } = useAppointmentServices(dispatch);

    return {
        callCacheService,
        getFinAccounts,
        callActionService,
        getAvailableDocuments,
        getClientUserStatus,
        putClientUserStatus,
        getYodleeResponse,
        getKycInfo,
        getClientPreferences,
        getAppointmentDetails,
        redirectToTimeTrade
    };
};
